import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clientenoengie',
  templateUrl: './clientenoengie.component.html',
  styleUrls: ['./clientenoengie.component.scss']
})
export class ClientenoengieComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
